import '../css/Footer.css';

const Footer = () => {
    return (
        <footer id="main-footer">
            <p>&copy; 2026 GarnetAndCode. All rights reserved.</p>
        </footer>
    );
};

export default Footer;  